import {EnvelopeIcon, PhoneIcon, XMarkIcon} from '@heroicons/react/24/outline'
import EncryptedEmail from "./EncryptedEmail";
import {SbBlokData, storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {RecaptchaProvider} from "../internal/RecaptchaProvider";
import {useRecaptchaVerify} from "../hooks/UseRecaptchaVerify";
import {toast} from "react-toastify";
import {useRouter} from "next/router";
import StyledMap from "./StyledMap";
import {useEffect, useState} from "react";
import OfficeLocation from "../content/OfficeLocation";
import {triggerPhoneConversion} from "../../utils/Helpers";
import {getConversionData} from "../../utils/getConversionData";
import dynamic from "next/dynamic";
import {richTextResolver} from "@storyblok/richtext";

type TProps = {
    blok: {
        title: string,
        subtitle: string,
        intro: any,
        subtext: string
    } & SbBlokData
}

const WrappedContactForm = (props: TProps) => {
    const {blok} = props;

    const router = useRouter();

    const {handleReCaptchaVerify} = useRecaptchaVerify();

    const [isSubmitting, setIsSubmitting] = useState(false);


    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
        company: '',
        howdidyouhear: '',
    });

    const { render } = richTextResolver()

    const submitForm = (e: any) => {
        e.preventDefault();
        setIsSubmitting(true)

        const formDataObj = new FormData(e.target);
        if (formDataObj.get("howdidyouhear") !== "") {
            // Form submission is spam
            return;
        }

        if (formData.howdidyouhear.length > 0) {
            return;
        }

        if (formData.message.length < 40 || formData.message.length > 2500) {
            toast('Please enter a message with at least 50 characters.', {
                type: 'error',
                position: 'bottom-right'
            });
            setIsSubmitting(false)
            return;
        }

        // handleReCaptchaVerify().then(token => {
                type P = keyof typeof formData;
                for (let key in formData) {
                    if (key !== 'company' && key !== 'howdidyouhear' && formData[key as P]?.length === 0) {
                        toast('Please fill out all fields.', {
                            type: 'error',
                            position: 'bottom-right'
                        });
                        setIsSubmitting(false)
                        return;
                    }
                }

                fetch("/api/contactmail", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ...formData,
                        ...getConversionData(),
                        // recaptcha: token
                    })
                }).then((res: any) => {
                    if (res.status !== 200) {
                        // Error
                        toast('Sorry, something went wrong. Please try again later.', {
                            type: 'error',
                            position: 'bottom-right'
                        });

                    } else {
                        // @ts-ignore
                        // window.gtag('event', 'conversion', {'send_to': 'AW-1001820813/RhqJCJ3fs_sBEI2l2t0D'});

                        window.gtag('event', 'conversion', {'send_to': 'AW-10838573329/c44VCKyd954DEJGCnrAo'});
                        // @ts-ignore
                        // window.gtag('event', 'contact_form_success');
                        // toast('Thank you for your message. We will get back to you as soon as possible.', {
                        //     type: 'success',
                        //     position: 'bottom-right'
                        // });

                        fetch("/api/hubspot", {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                ...formData,
                                // recaptcha: token
                            })
                        }).then((res: any) => {
                            router.push('/success')
                        })
                        // Redirect to thank you page

                    }
                });

            // }        )

    }

    return (
        <div className=" "  {...storyblokEditable(blok)}>

            <main className="overflow-hidden">
                {/* Header */}
                <div className="bg-white pt-16 lg:pt-24">
                    <div className="">
                        <div className="relative z-10 mx-auto max-w-7xl text-center pl-4 pr-8 px-4 sm:px-6 lg:px-8 pb-8">
                            <h1 className="text-4xl font-bold tracking-tight text-warm-gray-900 sm:text-5xl lg:text-6xl">
                                {blok.title}
                            </h1>
                            <div className="mt-6 max-w-4xl text-xl text-warm-gray-500 rich-text mx-auto"
                                 dangerouslySetInnerHTML={{
                                     __html: render(blok.intro) as string
                                 }}
                            >
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact section */}
                <section className="relative bg-white" aria-labelledby="contact-heading">
                    <div className="absolute h-1/2 w-full" aria-hidden="true"/>
                    {/* Decorative dot pattern */}
                    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <svg
                            className="absolute top-0 right-0 z-0 -translate-y-16 translate-x-1/2 transform sm:translate-x-1/4 md:-translate-y-24 lg:-translate-y-72"
                            width={404}
                            height={384}
                            fill="none"
                            viewBox="0 0 404 384"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-warm-gray-200"
                                          fill="currentColor"/>
                                </pattern>
                            </defs>
                            <rect width={404} height={384} fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"/>
                        </svg>
                    </div>
                    <div className="mx-auto max-w-3xl px-4 md:px-6 lg:px-8 pb-16 lg:pb-24">
                        <div className="relative bg-gray-50 shadow-xl">
                            <h2 id="contact-heading" className="sr-only">
                                Contact us
                            </h2>

                            <div className="">

                                {/* Contact form */}
                                <div className="py-10 px-6 sm:px-10 lg:col-span-2 xl:p-12">
                                    <h3 className="text-lg font-medium text-warm-gray-900">Send us a message</h3>
                                    <form action="#"
                                          onSubmit={submitForm}
                                          className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                                        <div>
                                            <label htmlFor="first-name"
                                                   className="block text-sm font-medium text-warm-gray-900">
                                                First name
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    value={formData.firstName}
                                                    onChange={e => setFormData({
                                                        ...formData,
                                                        firstName: e.target.value
                                                    })}
                                                    type="text"
                                                    name="first-name"
                                                    id="first-name"
                                                    autoComplete="given-name"
                                                    className="block w-full rounded-md border border-warm-gray-200 py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="last-name"
                                                   className="block text-sm font-medium text-warm-gray-900">
                                                Last name
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    value={formData.lastName}
                                                    onChange={e => setFormData({
                                                        ...formData,
                                                        lastName: e.target.value
                                                    })}
                                                    type="text"
                                                    name="last-name"
                                                    id="last-name"
                                                    autoComplete="family-name"
                                                    className="block w-full rounded-md border border-warm-gray-200  py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="email"
                                                   className="block text-sm font-medium text-warm-gray-900">
                                                Email
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    value={formData.email}
                                                    onChange={e => setFormData({
                                                        ...formData,
                                                        email: e.target.value
                                                    })}
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    autoComplete="email"
                                                    className="block w-full rounded-md border border-warm-gray-200  py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="flex justify-between">
                                                <label htmlFor="phone"
                                                       className="block text-sm font-medium text-warm-gray-900">
                                                    Phone
                                                </label>
                                                {/*                        <span id="phone-optional" className="text-sm text-warm-gray-500">*/}
                                                {/*  Optional*/}
                                                {/*</span>*/}
                                            </div>
                                            <div className="mt-1">
                                                <input
                                                    value={formData.phone}
                                                    onChange={e => setFormData({
                                                        ...formData,
                                                        phone: e.target.value
                                                    })}
                                                    type="text"
                                                    name="phone"
                                                    id="phone"
                                                    autoComplete="tel"
                                                    className="block w-full rounded-md border border-warm-gray-200  py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                                                    aria-describedby="phone-optional"
                                                />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                            <label htmlFor="last-name"
                                                   className="block text-sm font-medium text-warm-gray-900">
                                                Company
                                            </label>
                                            <div className="mt-1">
                                                <input
                                                    value={formData.company}
                                                    onChange={e => setFormData({
                                                        ...formData,
                                                        company: e.target.value
                                                    })}
                                                    type="text"
                                                    name="company"
                                                    id="company"
                                                    autoComplete="family-name"
                                                    className="block w-full rounded-md border border-warm-gray-200  py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                                                />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-2">
                                            <div className="flex justify-between">
                                                <label htmlFor="message"
                                                       className="block text-sm font-medium text-warm-gray-900">
                                                    Message
                                                </label>
                                                <span id="message-max" className="text-sm text-warm-gray-500">
                          Max. 500 characters
                        </span>
                                            </div>
                                            <div className="mt-1">
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={e => setFormData({...formData, message: e.target.value})}
                            rows={4}
                            className="block w-full rounded-md border border-warm-gray-200  py-3 px-4 text-warm-gray-900 shadow-sm focus:border-amber-300 focus:ring-amber-300 focus:outline-amber-300"
                            aria-describedby="message-max"
                        />
                                            </div>
                                        </div>
                                        <div className="sm:col-span-2 sm:flex sm:justify-end">
                                            <input name={'howdidyouhear'} id={'howdidyouhear'} type={'text'}
                                                   style={{
                                                       'visibility': 'hidden',
                                                       'zIndex': '-10',
                                                       'position': 'absolute'
                                                   }}
                                                   value={formData.howdidyouhear}
                                                   onChange={e => setFormData({
                                                       ...formData,
                                                       howdidyouhear: e.target.value
                                                   })}
                                            />
                                            <input
                                                type="submit"

                                                className={"mt-2 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-primary px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-amber-300 focus:ring-offset-2 sm:w-auto " + ((isSubmitting) ? "cursor-not-allowed opacity-50" : "")}
                                                value={'Submit'}
                                            />

                                        </div>

                                    </form>

                                    <section className="my-3">
                                        <figure className="mx-auto max-w-2xl">
                                            <p className="sr-only">5 out of 5 stars</p>
                                            <div className="flex gap-x-1 text-amber-400">
                                                <svg className="h-5 w-5 flex-none" viewBox="0 0 20 20"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd"
                                                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                <svg className="h-5 w-5 flex-none" viewBox="0 0 20 20"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd"
                                                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                <svg className="h-5 w-5 flex-none" viewBox="0 0 20 20"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd"
                                                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                <svg className="h-5 w-5 flex-none" viewBox="0 0 20 20"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd"
                                                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                                <svg className="h-5 w-5 flex-none" viewBox="0 0 20 20"
                                                     fill="currentColor" aria-hidden="true">
                                                    <path fillRule="evenodd"
                                                          d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z"
                                                          clipRule="evenodd"/>
                                                </svg>
                                            </div>
                                            <blockquote
                                                className="mt-2 text-lg font-semibold leading-8 tracking-tight text-gray-900 sm:text-2xl sm:leading-9">
                                                <p>“I recently worked with Pacific Codeline LLC developing enhancements to our e-commerce website, including a more streamlined efficient checkout process. Chris was very professional and easy to work with.”</p>
                                            </blockquote>
                                            <figcaption className="mt-2 flex items-center gap-x-6">
                                                <img className="h-12 w-12 rounded-full bg-gray-50"
                                                     src="https://www.pacificcodeline.com/_next/image?url=%2Fimages%2Ftestimonials%2Fbh.jpg&w=96&q=75"
                                                     alt=""/>
                                                <div className="text-sm leading-6">
                                                    <div className="font-semibold text-gray-900">Brad Handy</div>
                                                    <div className="mt-0.5 text-gray-600">President Lettering.com Inc</div>
                                                </div>
                                            </figcaption>
                                        </figure>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

        </div>
    )

}

export default function ContactForm(props: any) {
    return <RecaptchaProvider>
        <WrappedContactForm {...props} />
    </RecaptchaProvider>
}
